import { IAgreementPagedRequest } from '../../../../model/apm/agreement/request/agreement-paged-request';
import { IAgreementResponse } from '../../../../model/apm/agreement/response/agreement-response';

export type AgreementSearchState = {
    parameters: IAgreementPagedRequest;
    searchTrigger: number;
    drawer: { open: boolean; agreement?: IAgreementResponse };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
}

export const AgreementSearchReducer = (state: AgreementSearchState, action: any): AgreementSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, agreement: payload } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
